module.exports = __webpack_public_path__ + "img/plus-blue.f36ac4ab.svg";